/* eslint-disable complexity */
import React from "react"

import { CheckCircleFill } from "@walmart-web/livingdesign-icons"
import checkCircleFill from "assets/icons/check_circle_fill.svg"

import "./index.scss"
import { useIntl } from "react-intl"

interface PasswordCriteriaProps {
	criteriaErrors: any
}

const PasswordCriteria: React.FC<PasswordCriteriaProps> = ({
	criteriaErrors: { hasLength, hasCap, hasNumber, hasSpecialChar },
}) => {
	const intl = useIntl()

	return (
		<div className="criteria-section">
			<div className="criteria">
				{hasLength ? (
					<CheckCircleFill
						className="criteria-icon"
						size="small"
						data-testid="criteria-has-length"
					/>
				) : (
					<div data-testid="error-criteria-has-length">
						<img src={checkCircleFill} className="criteria-img" />
					</div>
				)}
				<span className="criteria-text">
					{intl.formatMessage({
						id: "phronesis.reset-password.form.password-criteria.length",
					})}
				</span>
			</div>
			<div className="criteria">
				{hasCap ? (
					<CheckCircleFill
						className="criteria-icon"
						size="small"
						data-testid="criteria-has-cap"
					/>
				) : (
					<div data-testid="error-criteria-has-cap">
						<img src={checkCircleFill} className="criteria-img" />
					</div>
				)}
				<span className="criteria-text">
					{intl.formatMessage({
						id: "phronesis.reset-password.form.password-criteria.cap-letter",
					})}
				</span>
			</div>
			<div className="criteria">
				{hasNumber ? (
					<CheckCircleFill
						className="criteria-icon"
						size="small"
						data-testid="criteria-has-number"
					/>
				) : (
					<div data-testid="error-criteria-has-number">
						<img src={checkCircleFill} className="criteria-img" />
					</div>
				)}
				<span className="criteria-text">
					{intl.formatMessage({
						id: "phronesis.reset-password.form.password-criteria.number",
					})}
				</span>
			</div>
			<div className="criteria">
				{hasSpecialChar ? (
					<CheckCircleFill
						className="criteria-icon"
						size="small"
						data-testid="criteria-has-special-char"
					/>
				) : (
					<div data-testid="error-criteria-has-special-char">
						<img src={checkCircleFill} className="criteria-img" />
					</div>
				)}
				<span className="criteria-text">
					{intl.formatMessage({
						id: "phronesis.reset-password.form.password-criteria.special-char",
					})}
				</span>
			</div>
		</div>
	)
}

export default PasswordCriteria
